import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ErrorService } from 'src/app/core/services/error.service';

@Component({
    selector: 'vee-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit{
  error: string = "";
  info: any;
  @Output() close: EventEmitter<void> = new EventEmitter();

  constructor(public svc: ErrorService) {
  }

  onClose() { this.svc.nextPageChecked(); }

  onClick() {
    this.svc.nextPageChecked();
  }

  ngOnInit(): void {
    // this.error = this.svc.info.error;
    this.info = this.svc.info;
  }

  get ErrorInformation() {
    return this.svc.info;
  }

}
